import cn from 'classnames';

import styles from './OrganizationRow.module.scss';
import { Row } from './Row';

type OrganizationRowProps = {
  className?: string;
  organizationName: string;
  initials: string;
  avatarSrc: string;
  onClick: () => void;
  isCurrentOrganization?: boolean;
  isMFARequired?: boolean;
};

export const OrganizationRow = (props: OrganizationRowProps) => {
  const {
    className,
    organizationName,
    avatarSrc,
    initials,
    onClick,
    isCurrentOrganization,
    isMFARequired,
  } = props;

  return (
    <div
      className={cn(styles.container, 'p2', className)}
      data-component="organization-row"
      onClick={onClick}
    >
      <Row
        organizationName={organizationName}
        initials={initials}
        isCurrentOrganization={isCurrentOrganization}
        isMFARequired={isMFARequired}
        avatarSrc={avatarSrc}
      />
    </div>
  );
};
